import { request } from '@blade/common';
/**
*@Description: 添加设备组
*/
export const deviceGroups = (data) => request({
    url: '/api/camera-device-management/api/v1/device-groups',
    method: 'POST',
    data
});
/**
*@Description: 查询设备组及设备树形列表
*/
export const devicesTree = (data) => request({
    url: '/api/camera-device-management/api/v1/device-groups/devices/tree',
    method: 'POST',
    data
});
/**
*@Description: 查询当前租户下所有的设备组树形列表
*/
export const deviceGroupsTree = (data) => request({
    url: '/api/camera-device-management/api/v1/device-groups/tree',
    method: 'POST',
    data
});
/**
*@Description: 查询设备组详情
*/
export const deviceGroupsDetail = (groupId) => request({
    url: `/api/camera-device-management/api/v1/device-groups/${groupId}`,
    method: 'GET'
});
/**
*@Description: 仅能修改名称和备注信息
*/
export const editDeviceGroups = (data, groupId) => request({
    url: `/api/camera-device-management/api/v1/device-groups/${groupId}`,
    method: 'PUT',
    data
});
/**
*@Description: 删除设备组
*/
export const deleteDeviceGroups = (groupId) => request({
    url: `/api/camera-device-management/api/v1/device-groups/${groupId}`,
    method: 'DELETE',
});
export const addPlatform = (data) => request({
    url: `/api/camera-device-management/api/v1/platform/info`,
    method: 'POST',
    data
});
export const editPlatform = (data) => request({
    url: `/api/camera-device-management/api/v1/platform/info`,
    method: 'PUT',
    data
});
// 查询平台列表
export const getPlatformList = () => request({
    url: `/api/camera-device-management/api/v1/platform/info/list`,
    method: 'GET',
});
// 添加平台设备信息时查询设备列表
export const getDeviceList = (platformId) => request({
    url: `/api/camera-device-management/api/v1/platform/info/platform/device/list/${platformId}`,
    method: 'POST',
});
// 删除平台
export const delPlatform = (id) => request({
    url: `/api/camera-device-management/api/v1/platform/info/${id}`,
    method: 'DELETE',
});
// 查询本地平台
export const getBasePlatform = () => request({
    url: `/api/camera-device-management/api/v1/platform/info/platform/base/info`,
    method: 'GET',
});
export const updateBasePlatform = (data) => request({
    url: `/api/camera-device-management/api/v1/platform/info/platform/base/info/update`,
    method: 'POST',
    data
});
// 批量删除设备
export const delBatchDelete = (data) => request({
    url: `/api/camera-device-management/api/v1/devices/delete/device`,
    method: 'POST',
    data
});
export const addBatchDelete = (data) => request({
    url: `/api/camera-device-management/api/v1/devices/add/device`,
    method: 'POST',
    data
});
/**
*@Description: 查询多类型设备树
*/
export const getDevicesGroupTree = (data) => request({
    url: `/api/camera-device-management/api/v1/devices/agg/devices/tree`,
    method: 'POST',
    data
});
// 批量导出设备
export const devicesExport = (data) => request({
    url: `/api/camera-device-management/api/v1/devices/export`,
    method: 'POST',
    data
});
// 按组批量导出设备
export const byExportGroup = (data) => request({
    url: `/api/camera-device-management/api/v1/devices/exportByGroup`,
    method: 'POST',
    data
});
